// @ts-nocheck
import * as React from 'react';
import type { CheckGroupProps, OptionType } from './CheckGroup.types';
import CheckGroupWrapper from './CheckGroup.styles';

const CheckGroup = ({ handleChange, options }: CheckGroupProps) => {
  const renderCheckboxes = ({ key, label, value }: OptionType) => {
    const onChange = () => handleChange(key, !value);

    return (
      <CheckGroupWrapper className='check' key={key}>
        <div
          className='check-container text-option-label'
          onClick={onChange}
          onKeyPress={onChange}
          role='button'
          tabIndex='0'
        >
          <span className={value ? 'active-check ' : 'checkmark'} />
          {label}
        </div>
      </CheckGroupWrapper>
    );
  };

  return <>{options.map((option) => renderCheckboxes(option))}</>;
};

export default CheckGroup;
